<template>
  <div class="social-link">
    <BHLink
      :href="href"
      target="_blank"
      @click="$emit('click-menu-item')"
    >
      <img
        v-if="imageSrc"
        :src="imageSrc"
        :alt="link.title"
        width="24"
        height="24"
        class="social-link__icon"
      />
    </BHLink>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BHLink from '~/components/BHLink.vue';
  import type { ILink } from '~/components/ArrowMenu/ArrowMenu';
  import { removeBurninghutFromUrl } from '~/utils/link';

  import vkPath from '@/assets/images/svg/vk.svg';
  import telegramPath from '@/assets/images/svg/telegram.svg';
  import twitterPath from '@/assets/images/svg/twitter.svg';
  import pinterestPath from '@/assets/images/svg/pinterest.svg';
  import youtubePath from '@/assets/images/svg/youtube.svg';
  import viberPath from '@/assets/images/svg/viber.svg';
  import classmatesPath from '@/assets/images/svg/classmates.svg';
  import dzenPath from '@/assets/images/svg/yandex-dzen.svg';
  import rssPath from '@/assets/images/svg/rss.svg';

  export default defineNuxtComponent({
    name: 'BurgerSocialLink',

    components: { BHLink },

    props: {
      link: {
        type: Object as PropType<ILink>,
        required: true,
      },
    },

    emits: ['click-menu-item'],

    computed: {
      imageSrc() {
        switch (this.link.title) {
          case 'Telegram':
            return telegramPath;
          case 'Viber':
            return viberPath;
          case 'ВКонтакте':
            return vkPath;
          case 'Twitter':
            return twitterPath;
          case 'YouTube':
            return youtubePath;
          case 'Одноклассники':
            return classmatesPath;
          case 'Pinterest':
            return pinterestPath;
          case 'Яндекс.Дзен':
            return dzenPath;
          case 'RSS':
            return rssPath;
          default:
            return '';
        }
      },

      href() {
        return removeBurninghutFromUrl(this.link.link);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .social-link {
    display: block;
    width: 56px;
    height: 56px;
    padding: $spacing-4;

    &__icon {
      @include hover {
        filter: brightness(0.8);
      }
    }
  }
</style>
